import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'antd';

import ListingWizardLayout from 'layouts/ListingWizardLayout/ListingWizardLayout';
import FormInput from 'components/FormInput/FormInput';
import FormSelection from 'components/FormSelection/FormSelection';
import intl from 'react-intl-universal';

import styles from './BasicDetails.module.css';

class BasicDetails extends React.Component {
  handleOnSubmit = e => {
    e.preventDefault();
    const { form, onSave } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onSave(values);
      }
    });
  };

  render() {
    const { defaultValues, form, hasFetchedPropertyTypes, isLastPage, onBack, percentage, propertyTypes, title } = this.props;
    return (
      <ListingWizardLayout
        isLastPage={isLastPage}
        percentage={percentage}
        title={title}
        onBackButtonClick={onBack}
        onNextButtonClick={this.handleOnSubmit}
      >
        <Row type="flex" justify="space-between" className={styles.formTitleContainer}>
          <h2 className={styles.formTitle}>{intl.get('listings.property.tell').d('Tell us more about your property')}</h2>
        </Row>

        <Row type="flex" justify="space-between" className={styles.formItemContainer}>
          <Col span={24} className={styles.formItem}>
            <FormInput
              label={intl.get('listings.property.name').d('Property Name')}
              name="name"
              placeholder={intl.get('listings.property.property').d('Type in your property name')}
              requiredErrorMessage={intl.get('listings.property.propertyMsg').d('Please provide a property name')}
              form={form}
              defaultValue={defaultValues.name}
              size="large"
            />
          </Col>
        </Row>
        <Row type="flex" justify="space-between" className={styles.formItemContainer}>
          <Col span={24} className={styles.formItem}>
            <FormSelection
              name="type"
              label={intl.get('listings.property.type').d('Type')}
              requiredErrorMessage={intl.get('listings.property.propertyTypeMsg').d('Please select your property type')}
              placeholder={intl.get('listings.property.propertyType').d('Choose your property type')}
              form={form}
              defaultValue={defaultValues.type}
              shouldDisable={!hasFetchedPropertyTypes}
              selections={propertyTypes}
              size="large"
            />
          </Col>
        </Row>
      </ListingWizardLayout>
    );
  }
}

BasicDetails.propTypes = {
  form: PropTypes.object.isRequired,
  hasFetchedPropertyTypes: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  percentage: PropTypes.number.isRequired,
  propertyTypes: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  defaultValues: PropTypes.object,
  isLastPage: PropTypes.bool,
  onBack: PropTypes.func
};

BasicDetails.defaultProps = {
  defaultValues: {},
  hasFetchedPropertyTypes: false,
  isLastPage: false,
  propertyTypes: []
};

const WrappedFormBasicDetails = Form.create()(BasicDetails);

export default WrappedFormBasicDetails;
